import { cn } from "@u/cn";

type CharCountProps = {
  /** Current length, or the string/array to measure. */
  value: number | string | unknown[];
  /** Max allowed (the denominator + the warning threshold). */
  max: number;
  className?: string;
};

/**
 * Canonical `{n}/{max}` counter for text fields / capped lists. Single source
 * for the color ramp — muted normally, warning near the cap (≥90%), destructive
 * once over. Replaces the hand-rolled `{x.length}/{N}` spans (was ~30 sites, all
 * styled slightly differently). `tabular-nums` keeps the width from jittering.
 */
export function CharCount({ value, max, className }: CharCountProps) {
  const len =
    typeof value === "number" ? value : typeof value === "string" ? value.length : value.length;
  const over = len > max;
  const near = !over && len >= max * 0.9;
  return (
    <span
      aria-live="polite"
      className={cn(
        "label-micro shrink-0 tabular-nums",
        over
          ? "text-destructive"
          : near
            ? "text-warning-strong"
            : "text-muted-foreground",
        className,
      )}
    >
      {len}/{max}
    </span>
  );
}
